import { FileTrackerFileStats } from '../file-tracker-types';
import { useEffect, useState } from 'react';
import { Flex, Icon, Tooltip } from '@chakra-ui/react';
import { SummaryCard, bytesToSize } from '@ssar-app/uikit';
import {
  AiOutlineClockCircle,
  AiOutlineDatabase,
  AiOutlineInfoCircle,
} from 'react-icons/ai/index.js';
import { IconType } from 'react-icons';

interface FileStatProps {
  fileData: FileTrackerFileStats;
}
interface FileStats {
  title: string;
  value: number | string;

  icon: IconType | undefined;
  color: string;
  background: string;
  secondaryTitle?: IconType | undefined;
}

export const FileStatsView = (props: FileStatProps) => {
  const { fileData } = props;

  const getStats = (fileStats: FileTrackerFileStats) => {
    return [
      {
        title: 'Avg time to receive files',
        value: `${fileStats.avgFileAvailableTime} hrs`,
        icon: AiOutlineClockCircle,
        color: '#426dA9',
        background: '#D6E3F4',
      },
      {
        title: 'Avg files size',
        value: bytesToSize(fileStats.avgFileSize * 1024 * 1000),
        icon: AiOutlineDatabase,
        color: '#A45DAD',
        background: '#F0DEF2',
      },
      {
        title: 'Large files count',
        secondaryTitle: AiOutlineInfoCircle,
        value: fileStats.largeFiles,
        icon: AiOutlineClockCircle,
        color: '#FF8F1C',
        background: '#FFEED7',
      },
      {
        title: 'Total files',
        value: fileStats.totalFiles,
        icon: AiOutlineClockCircle,
        color: '#29B769',
        background: '#D0F6DB',
      },
    ];
  };

  const [fileStats, setFileStats] = useState<FileStats[]>(
    getStats({
      avgFileAvailableTime: 0,
      avgFileSize: 0,
      largeFiles: 0,
      totalFiles: 0,
    }),
  );

  useEffect(() => {
    setFileStats(getStats(fileData));
  }, [fileData]);
  return (
    <Flex gap={3} mt={3}>
      {fileStats.map((fileStat, index) => (
        <SummaryCard
          key={index}
          icon={
            <Icon as={fileStat.icon} color={fileStat.color} fontSize='2xl' />
          }
          title={fileStat.title}
          secondaryTitle={
            fileStat.secondaryTitle ? (
              <Tooltip
                label='Only files that are 10GB or greater are counted'
                placement='top'
              >
                <span>
                  <Icon
                    as={fileStat.secondaryTitle}
                    color={fileStat.color}
                    fontSize='xl'
                  />
                </span>
              </Tooltip>
            ) : (
              ''
            )
          }
          secondaryTitleProps={
            fileStat.secondaryTitle
              ? { position: 'absolute', top: '1px', left: '100px' }
              : undefined
          }
          details={fileStat.value}
          iconsBackground={fileStat.background}
        />
      ))}
    </Flex>
  );
};
